module.exports = __webpack_public_path__ + "static/media/planet-exploration.30f8e681.webp";